import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { Theme } from '@desygner/ui-common-components';

const radius = Theme.Border.Radius.Small;

const Wrapper = styled.a`
  position: absolute;
  display: block;
  right: 0;
  font-family: 'Nunito';
  width: ${({ size }) => size}px;
  height: ${({ inline }) => inline ? '32px' : '50px'};
  padding: ${({ inline }) => inline ? '0' : '6px'};
  font-weight: ${({ theme }) => theme.Typography.FontWeight.SemiBold};
  line-height: 32px;
  text-align: ${({ inline }) => inline ? 'center' : 'left'};
  color: ${(props) => props.theme.Color.Neutrals.Dark};
  background: ${(props) => props.theme.Color.System.Light};
  pointer-events: all;
  cursor: pointer;
  ${({ isPositionTop }) => isPositionTop
    ? css`
      bottom: 2px;
      border-radius: ${radius} ${radius} 0 0;
    `
    : css`
      top: 0;
      border-radius:  0 0 ${radius} ${radius};
    `}

  &:hover,
  &:focus,
  &:target {
    color: ${(props) => props.theme.Color.Neutrals.Dark};
  }
`;

const Label = styled.span`
  display: block;
  font-size: 14px;
  line-height: ${({ featured }) => featured ? '32px' : '20px'};
  color: ${(props) => props.theme.Color.Neutrals.Dark};
`;
const Description = styled.span`
  display: block;
  font-size: 12px;
  line-height: 16px;
  color: ${(props) => props.theme.Color.Neutrals.Text};
  opacity: 0.6;
`;

export default function HeaderAndFooterLabel ({
  label,
  description,
  position = 'top',
  size,
  onClick
}) {
  return (
    <Wrapper
      isPositionTop={position === 'top'}
      size={size}
      onClick={onClick}
      inline={!description}
    >
      <Label featured={!description}>{label}</Label>
      {description && <Description>{description}</Description>}
    </Wrapper>
  );
}

HeaderAndFooterLabel.propTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  size: PropTypes.number.isRequired,
  position: PropTypes.oneOf(['top', 'bottom']),
  onClick: PropTypes.func
};
